import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AbstractIdentityConfigService } from '../../abstract-identity-config/abstract-identity-config.service';
import { AbstractService } from '../abstract-http/abstract-service';
import { User } from '../../../models/domain';
import { RoleEnum } from '@anecdotes/auth-core';

@Injectable()
export class UserService extends AbstractService {
  constructor(http: HttpClient, configService: AbstractIdentityConfigService) {
    super(http, configService);
  }

  getAllUsers(): Observable<User[]> {
    return this.http.get<User[]>(this.buildUrl(({ getUser }) => getUser));
  }

  updateUser(user_email: string): Observable<any> {
    return this.http.put(
      this.buildUrl(({ updateUser }) => updateUser, { user_email }),
      user_email
    );
  }

  patchUser(user: User): Observable<User> {
    // TODO: AN-9388
    // We need to map exisiting Manager to Collaborator
    // So the platform can treat managers as collaborators
    // until BE is fully migrated
    if (user.role === RoleEnum.Collaborator) {
      user = {
        ...user,
        role: RoleEnum.Manager
      };
    }

    return this.http.patch<User>(this.buildUrl(({ patchUser }) => patchUser, { user_email: user.email }), user);
  }

  createNewUser(user: User, notification?: Record<string, string>): Observable<User> {
    // TODO: AN-9388
    // We need to map exisiting Manager to Collaborator
    // So the platform can treat managers as collaborators
    // until BE is fully migrated
    if (user.role === RoleEnum.Collaborator) {
      user = {
        ...user,
        role: RoleEnum.Manager,
      };
    }

    const payload: Record<string, unknown> = {
      user,
    };

    if (notification) {
      payload['notification'] = notification;
    }

    return this.http.post<User>(
      this.buildUrl(({ addUser }) => addUser),
      payload,
    );
  }

  removeSpecificUser(userEmail: string): Observable<any> {
    return this.http.delete<any>(this.buildUrl(({ deleteUser }) => deleteUser, { user_email: userEmail }));
  }
}
